
interface DetailedErrorInfoProps {
  errorDetails: string;
}

export const DetailedErrorInfo = ({ errorDetails }: DetailedErrorInfoProps) => {
  return (
    <div className="mt-8 p-4 border border-red-300 rounded-md bg-red-50 text-red-800 max-w-5xl mx-auto overflow-auto">
      <h3 className="font-semibold mb-2">Detailed Error Information</h3>
      <pre className="text-xs overflow-auto whitespace-pre-wrap max-h-60">
        {errorDetails}
      </pre>
    </div>
  );
};
